import React from 'react';
import { tr } from '../i18n';

export const ExtrasBox = ({ items, lang, compact = false }) => {
  if (!items.length) return null;
  return (
    <div
      data-testid="extras-box"
      className={compact ? 'mt-4 border-t border-black/30 pt-3' : 'mt-12 border-[1.5px] border-black rounded-2xl p-5 md:p-6 bg-white'}
    >
      <p className={`font-bold uppercase tracking-[0.28em] text-black/60 mb-3 ${compact ? 'text-xs' : 'text-[11px] text-center'}`}>
        {lang === 'it' ? 'Aggiunte' : 'Extras'}
      </p>
      <ul className={`grid grid-cols-1 ${compact ? 'md:grid-cols-3 gap-x-6 gap-y-1' : 'sm:grid-cols-2 gap-x-8 gap-y-2'}`}>
        {items.map((x, i) => (
          <li key={x._id || i} className="flex items-baseline gap-2" data-testid={`extra-item-${i}`}>
            <span translate="no" className={`notranslate font-medium text-black ${compact ? 'text-xs' : 'text-sm md:text-base'}`}>{tr(x.name, lang)}</span>
            <span className="flex-1 border-b border-dotted border-black/30 translate-y-[-3px]" />
            <span className={`font-display whitespace-nowrap ${compact ? 'text-sm' : 'text-base'}`}>+ € {x.price}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ExtrasBox;
